import React, {useEffect, useRef, useState} from "react";
import _events_service from "../../service/EventsService";
import './EventsOverlay.scss';
import './EventsOverlayFollow.scss';
import './EventsOverlaySub.scss';
import './EventsOverlayGift.scss';
import './EventsOverlayCheer.scss';
import './EventsOverlayRaid.scss';
import './EventsOverlayDonationDefault.scss';
import './EventsOverlayDonationGo.scss';
import './EventsOverlayDonationPb.scss';

interface StreamOverlayState {
    username: string;
    count?: number;
    tier?: string;
    pfp?: string;
    receiver?: string;
    message?: string;
}

const EventsOverlay = () => {

    const _follow_event_duration_in_seconds = 15;
    const _sub_event_duration_in_seconds = 15;
    const _gift_event_duration_in_seconds = 20;
    const _cheer_event_duration_in_seconds = 15;
    const _raid_event_duration_in_seconds = 20;
    const _donation_event_duration_in_seconds = 20;
    const _go_event_duration_in_seconds = 10;
    const _pb_event_duration_in_seconds = 15;

    const _default_state: StreamOverlayState = {
        username: 'ChaseTheRedFox',
        count: 42,
        pfp: 'https://static-cdn.jtvnw.net/jtv_user_pictures/f49d8c27-b774-4f8e-a304-b1ad6e96d2e6-profile_image-70x70.png',
        tier: 'aus',
        receiver: 'TestUser',
        message: 'This is a really long test message! What are you gonna do about it? AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA!'
    };

    const [state, setState] = useState<StreamOverlayState>({username: 'TestUser', count: 5});

    const sfxRef = useRef<{[name: string]: HTMLAudioElement | null}>({});

    useEffect(() => {
        sfxRef.current['follow'] = new Audio('/sound/follow.mp3');
        sfxRef.current['sub'] = new Audio('/sound/sub.mp3');
        sfxRef.current['gift'] = new Audio('/sound/gift.mp3');
        sfxRef.current['raid'] = new Audio('/sound/raid.mp3');
        sfxRef.current['donation-default'] = new Audio('/sound/donation.mp3');
        sfxRef.current['donation-kka'] = new Audio('/sound/hauoli.mp3');
        sfxRef.current['donation-vss'] = new Audio('/sound/hauoli.mp3');
        sfxRef.current['donation-hs'] = new Audio('/sound/hauoli.mp3');
        sfxRef.current['donation-jj'] = new Audio('/sound/winter.mp3');
        sfxRef.current['donation-pb'] = new Audio('/sound/hauoli.mp3');
        for (let sfx in sfxRef.current) {
            if (sfxRef.current[sfx]) {
                sfxRef.current[sfx]!.volume = 0.8;
                sfxRef.current[sfx]!.loop = false;
            }
        }

        return () => {
            for (let sfx in sfxRef.current) {
                if (sfxRef.current[sfx]) {
                    sfxRef.current[sfx]!.pause();
                    sfxRef.current[sfx] = null;
                }
            }
        };
    }, []);

    const poll = async (lastEventIndex: number, previousWaitTimeMs: number = 1000) => {
        await _events_service.getNextOverlayEvent(lastEventIndex)
            .then(response => {
                if (!response) {
                    setTimeout(() => poll(lastEventIndex), 1000);
                    console.log('no response');
                    return;
                } else {
                    switch (response.type) {
                        case 'follow':
                            setState({
                                username: response.username
                            });
                            follow();
                            setTimeout(() => poll(lastEventIndex + 1), (_follow_event_duration_in_seconds + 1) * 1000);
                            console.log('follow: ' + lastEventIndex);
                            return;
                        case 'sub':
                            setState({
                                username: response.username,
                                count: response.count,
                                tier: response.tier,
                                message: response.message
                            });
                            sub();
                            setTimeout(() => poll(lastEventIndex + 1), (_sub_event_duration_in_seconds + 1) * 1000);
                            console.log('sub: ' + lastEventIndex);
                            return;
                        case 'gift':
                            setState({
                                username: response.username,
                                count: response.count,
                                tier: response.tier,
                                receiver: response.receiver
                            });
                            gift();
                            setTimeout(() => poll(lastEventIndex + 1), (_gift_event_duration_in_seconds + 1) * 1000);
                            console.log('gift: ' + lastEventIndex);
                            return;
                        case 'cheer':
                            setState({
                                username: response.username,
                                count: response.count,
                                tier: response.tier,
                                message: response.message
                            });
                            cheer();
                            setTimeout(() => poll(lastEventIndex + 1), (_cheer_event_duration_in_seconds + 1) * 1000);
                            console.log('cheer: ' + lastEventIndex);
                            return;
                        case 'raid':
                            setState({
                                username: response.username,
                                count: response.count,
                                pfp: response.pfp
                            });
                            raid();
                            setTimeout(() => poll(lastEventIndex + 1), (_raid_event_duration_in_seconds + 1) * 1000);
                            console.log('raid: ' + lastEventIndex);
                            return;
                        case 'donation':
                            setState({
                                username: response.username,
                                count: response.count || 0,
                                receiver: response.receiver || 'default',
                                tier: response.tier
                            });
                            donation(response.receiver || 'default');
                            setTimeout(() => poll(lastEventIndex + 1), (_donation_event_duration_in_seconds + 1) * 1000);
                            console.log('donation: ' + lastEventIndex);
                            return;
                        default:
                            setTimeout(() => poll(lastEventIndex), 1000);
                            console.log('none: ' + lastEventIndex);
                            return;
                    }
                }
            })
        .catch(() => setTimeout(() => poll(previousWaitTimeMs * 2),
            Math.min(previousWaitTimeMs * 2, 5000)));
    };

    const follow = () => {
        activateImg('.stream-overlay-follow-image', '/images/gb_chase.gif', _follow_event_duration_in_seconds * 1000);
        activate('.stream-overlay-follow-message', _follow_event_duration_in_seconds * 1000);
        playSound(sfxRef.current['follow']);
    };

    const sub = () => {
        activateImg('.stream-overlay-sub-image', '/images/envelope.gif', _sub_event_duration_in_seconds * 1000);
        activate('.stream-overlay-sub-message', _sub_event_duration_in_seconds * 1000);
        setTimeout(() => {
            activate('.stream-overlay-sub-viewer-message', (_sub_event_duration_in_seconds * 1000) - 1800);
        }, 1800);
        playSound(sfxRef.current['sub']);
    };

    const gift = () => {
        activateImg('.stream-overlay-gift-image', '/images/mystery_gift.gif',
            _gift_event_duration_in_seconds * 1000);
        activate('.stream-overlay-gift-message', (_gift_event_duration_in_seconds * 1000));
        // setTimeout(() => gift(), 22000);
        playSound(sfxRef.current['gift']);
    }

    const cheer = () => {
        setTimeout(() => {
           activate('.stream-overlay-cheer-message', _cheer_event_duration_in_seconds * 1000);
           activate('.stream-overlay-cheer-viewer-message', _cheer_event_duration_in_seconds * 1000);
        }, 500);
    };

    const donation = (recipient: string) => {
        if (['go', 'vss', 'hs', 'jj'].includes(recipient)) {
            donationGo(recipient);
        } else if (['als', 'pb'].includes(recipient)) {
            donationPb(recipient);
        } else {
            activateImg(`.stream-overlay-donation-image`, `/images/coin.gif`,
                _donation_event_duration_in_seconds * 1000);
            setTimeout(() => {
                activate(`.stream-overlay-donation-message`, _donation_event_duration_in_seconds * 1000);
                activate(`.stream-overlay-donation-viewer-message`, _donation_event_duration_in_seconds * 1000);
            }, 500);
            playSound(sfxRef.current['donation-default']);
        }
    };

    const donationGo = (eventType: string) => {
        let goEvent: string = eventType;
        if (eventType === 'go') {
            goEvent = getGoEvent();
        }
        activate(`.stream-overlay-donation-go-image`, _go_event_duration_in_seconds * 1000);
        setTimeout(() => {
            activate(`.stream-overlay-donation-go-message`, _go_event_duration_in_seconds * 1000);
            activate(`.stream-overlay-donation-go-viewer-message`, _go_event_duration_in_seconds * 1000);
        }, 500);
        playSound(sfxRef.current[`donation-${goEvent}`]);
    }

    const donationPb = (eventType: string) => {
        activate(`.stream-overlay-donation-pb-image`, _pb_event_duration_in_seconds * 1000);
        setTimeout(() => {
            activate(`.stream-overlay-donation-pb-message`, _pb_event_duration_in_seconds * 1000);
            activate(`.stream-overlay-donation-pb-viewer-message`, _pb_event_duration_in_seconds * 1000);
        }, 500);
        playSound(sfxRef.current[`donation-pb`]);
    }

    const raid = () => {
        activate('.stream-overlay-raid', _raid_event_duration_in_seconds * 1000);
        // setTimeout(() => {
        //     activate('.stream-overlay-raid-stars-1', _raid_event_duration_in_seconds * 1000);
        //     activate('.stream-overlay-raid-stars-2, _raid_event_duration_in_seconds * 1000);
        // }, 1000);
        setTimeout(() => {
            activate('.stream-overlay-raid-bar-message', (_raid_event_duration_in_seconds - 3) * 1000);
        }, 3000);
        playSound(sfxRef.current['raid']);
    };

    const activateImg = (element: string, src: string, time: number = 1000): void => {
        const img = document.querySelector(element) as HTMLImageElement;
        if (!img) return;

        img.src = '';
        img.classList.remove('is-active');
        void (img as HTMLElement).offsetWidth;

        img.src = src + '?t=' + new Date().getTime();
        img.classList.add('is-active');

        setTimeout(() => img.classList.remove('is-active'), time);
    };

    const activate = (element: string, time: number = 1000): void => {
        const el = document.querySelector(element);
        if (!el) return;

        el.classList.remove('is-active');
        void (el as HTMLElement).offsetWidth;

        el.classList.add('is-active');

        setTimeout(() => el.classList.remove('is-active'), time);
    };

    const playSound = (audioRef: HTMLAudioElement | null) => {
        if (!audioRef) {
            return;
        }

        audioRef.currentTime = 0;
        audioRef.play().catch(e => console.error(e));
    };

    const getGoEvent = () => {
        const month = new Date().getMonth() + 1;
        if (month === 12) {
            return 'jj';
        } else if (month >= 10) {
            return 'hs';
        } else {
            return 'vss';
        }
    };

    useEffect(() => {
        setState(_default_state);
        // follow();
        // sub();
        // raid();
        // cheer();
        // gift();
        // donation('pb');
        //setTimeout(() =>  donation('go'), 12000);
        _events_service.getCurrentEventCount().then(count => {
            poll(count).catch(e => console.error(e));
        });
    }, []);

    return (
        <>
            <div className="stream-overlay">
                <div className="stream-overlay-follow">
                    <img className="stream-overlay-follow-image"
                         src="/images/gb_chase.gif"
                         alt="" />
                    <div className="stream-overlay-follow-message">
                        <span>
                            <strong className="stream-overlay-highlight">{state.username}</strong> is now following!<br/>
                            Shakas up, Fox Fam!
                        </span>
                    </div>
                </div>
                <div className="stream-overlay-sub">
                    <img className="stream-overlay-sub-image"
                         src="/images/envelope.gif"
                         alt="" />
                    <div className="stream-overlay-sub-message">
                        {state.tier?.toLowerCase().startsWith('tier') ?
                            <span>
                                <strong className="stream-overlay-highlight">{state.username}</strong> has
                                subscribed at <strong className="stream-overlay-highlight">{state.tier}</strong>!<br/>
                                They've been subscribed for {state.count} months!
                            </span>
                            :
                            <span>
                                <strong className="stream-overlay-highlight">{state.username}</strong> has subscribed
                                with <strong className="stream-overlay-highlight">Prime gaming</strong>!<br/>
                                They've been subscribed for {state.count} months!
                            </span>
                        }
                    </div>
                    <div className="stream-overlay-sub-viewer-message">
                        <br/>
                        {state.message && <span>{state.message}</span>}
                    </div>
                </div>
                <div className="stream-overlay-gift">
                    <img className="stream-overlay-gift-image"
                         src="/images/mystery_gift.gif"
                         alt="" />
                    <div className="stream-overlay-gift-message">
                        {state.receiver ?
                            <span>
                                <strong className="stream-overlay-highlight">{state.username}</strong> has
                                invited <strong className="stream-overlay-highlight">{state.receiver}</strong> to<br/>
                                become a Fox Fam subscriber!
                            </span>
                            :
                            <span>
                                <strong className="stream-overlay-highlight">{state.username}</strong> has
                                invited <strong className="stream-overlay-highlight">{state.count}</strong> new member{state.count! > 1 ? 's' : ''}<br/>
                                to become {state.count! > 1 ? ' ' : 'a '}Fox Fam subscriber{state.count! > 1 ? 's' : ''}!
                            </span>
                        }
                    </div>
                </div>
                <div className="stream-overlay-raid">
                    <div className="stream-overlay-raid-bar">
                        <div className="stream-overlay-raid-bar-message">
                            <span>{state.username} raided with {state.count} viewers!</span>
                        </div>
                        <img className="stream-overlay-raid-bar-pfp" src={state.pfp} alt=""/>
                        <img className="stream-overlay-raid-bar-bg" src="/images/mega_man_boss_intro.png" alt=""/>
                    </div>
                    <div className="stream-overlay-raid-stars-1" />
                    <div className="stream-overlay-raid-stars-2" />
                </div>
                <div className="stream-overlay-cheer">
                    <img className="stream-overlay-cheer-image"
                         src="/images/coin.gif"
                         alt="" />
                    <div className="stream-overlay-cheer-message">
                        <span>
                            <strong className="stream-overlay-highlight">{state.username}</strong> cheered
                            x<strong className="stream-overlay-highlight">{state.count}</strong>!
                        </span>
                    </div>
                    <div className="stream-overlay-cheer-viewer-message">
                        <br/>
                        {state.message && <span>{state.message}</span>}
                    </div>
                </div>
                <div className="stream-overlay-donation">
                    <img className="stream-overlay-donation-image"
                         src="/images/coin.gif"
                         alt="" />
                    <div className="stream-overlay-donation-message">
                        <span>
                            <strong className="stream-overlay-highlight">{state.username}</strong> donated <strong className="stream-overlay-highlight" hidden={state.count === 0}>
                                {state.tier === 'usd' && '$'}{state.count! / 100.0}{state.tier !== 'usd' && ' ' + state.tier?.toUpperCase()}
                            </strong>!
                        </span>
                    </div>
                </div>
                <div className="stream-overlay-donation-go">
                    <video className="stream-overlay-donation-go-image" autoPlay loop>
                        <source src={`/images/${getGoEvent()}.webm`} type="video/webm" />
                    </video>
                    <div className="stream-overlay-donation-go-message">
                        <span>
                            <strong className={`stream-overlay-${getGoEvent()}-highlight`}>{state.username}</strong> donated <strong className={`stream-overlay-${getGoEvent()}-highlight`} hidden={state.count === 0}>
                                {state.tier === 'usd' && '$'}{state.count! / 100.0}{state.tier !== 'usd' && ' ' + state.tier?.toUpperCase()}
                            </strong>!
                        </span>
                    </div>
                </div>
                <div className="stream-overlay-donation-pb">
                    <img className="stream-overlay-donation-pb-image"
                         src="/images/papabarks2026.png"
                         alt="" />
                    <div className="stream-overlay-donation-pb-message">
                        <span>
                            <strong className={`stream-overlay-highlight`}>{state.username}</strong> donated <strong className={`stream-overlay-highlight`} hidden={state.count === 0}>
                                {state.tier === 'usd' && '$'}{state.count! / 100.0}{state.tier !== 'usd' && ' ' + state.tier?.toUpperCase()}
                            </strong>!
                        </span>
                    </div>
                </div>
            </div>
        </>
    );
}

export default EventsOverlay;